/**
 * Constants for salary calculations
 * Updated for French social contributions 2025
 */

// Working hours constants
export const WORKING_HOURS = {
  HOURS_PER_YEAR: 1820, // 35h/week * 52 weeks
  HOURS_PER_MONTH: 1820 / 12, // ~151.67h
  WEEKS_PER_YEAR: 52,
  HOURS_PER_WEEK: 35
};

// Social contribution rates by professional status
export const SOCIAL_CONTRIBUTION_RATES = {
  non_cadre: {
    cotisations_sociales: 0.11,
    csg_crds: 0.097,
    autres_deductions: 0.00
  },
  cadre: {
    cotisations_sociales: 0.12,
    csg_crds: 0.097,
    autres_deductions: 0.01
  },
  fonction_publique: {
    cotisations_sociales: 0.11,
    csg_crds: 0.097,
    autres_deductions: 0.01
  },
  profession_liberale: {
    cotisations_sociales: 0.35,
    csg_crds: 0.097,
    autres_deductions: 0.02
  },
  portage_salarial: {
    cotisations_sociales: 0.12,
    csg_crds: 0.097,
    autres_deductions: 0.11
  }
};

// Professional status labels
export const STATUS_LABELS = {
  non_cadre: 'Non-cadre',
  cadre: 'Cadre',
  fonction_publique: 'Fonction publique',
  profession_liberale: 'Profession libérale',
  portage_salarial: 'Portage salarial'
};

// Sample calculations for the examples table
export const SALARY_EXAMPLES = [
  { brut: '2000', status: 'Non-cadre', net: '1586' },
  { brut: '3000', status: 'Cadre', net: '2277' },
  { brut: '4000', status: 'Fonction publique', net: '3136' },
  { brut: '5000', status: 'Profession libérale', net: '2765' }
];

// Tips for salary negotiation and understanding
export const SALARY_TIPS = [
  "Négociez en connaissant votre net réel pour éviter les mauvaises surprises",
  "Vérifiez les impacts fiscaux annuels avec votre comptable",
  "Pensez aux avantages en nature qui s'ajoutent au salaire net",
  "Les taux peuvent varier selon la convention collective",
  "Anticipez les prélèvements à la source sur votre net"
];